import script from "./AppTopBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTopBar.vue?vue&type=script&setup=true&lang=js"

import "./AppTopBar.vue?vue&type=style&index=0&id=bf494c94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf494c94"]])

export default __exports__